module.exports = __webpack_public_path__ + "img/icon_option_set_5.a408acb3.svg";